import { configField, makeConfig } from "@megaron/config-manager";
import { Serializers } from "@megaron/serializers";

import { LogLevel, logLevels } from "./BaseLogger";

export const LoggerConfig = makeConfig({
  logName: configField("app"),
  prettyLogging: configField({ default: false, nonProd: true }, Serializers.booleanString),
  logLevel: configField<LogLevel>({ default: "trace", test: "error" }, Serializers.stringOneOf(...logLevels)),
});
